import endpointConfig from "../configs/endpoint.config";
import httpConfig from "../configs/http.config";
import { 
  MapsAutocompleteBodyProps, 
  MapsAutocompleteResponseProps, 
  MapsGeocodeBodyProps, 
  MapsGeocodeResponseProps, 
} from "../types/maps.type";

const mapsService = {
  autocomplete: async function(body: MapsAutocompleteBodyProps, signal?: AbortSignal) {
    const response = await httpConfig().post<MapsAutocompleteResponseProps>(endpointConfig.maps.autocomplete, body, { signal })
    return response.data
  },
  geocode: async function(body: MapsGeocodeBodyProps) {
    const response = await httpConfig().post<MapsGeocodeResponseProps>(endpointConfig.maps.geocode, body)
    return response.data
  }
}

export default mapsService